<template>
    <div>
        <div class="container remove-padding-margin" id="listepayment">
            <div class="fixed-judul fixed-top">
                <div class="row justify-content-center align-items-center set-row showPageDefault">
                    <div class="col-md-1 col-sm-1 col-1 remove-padding">
                        <img @click="back" src="../../assets/gambar/back-blue.svg" alt="">
                    </div>
                    <div class="col-md-10 col-sm-10 col-10 text-center remove-padding">
                        <h6 class="remove-margin font-16 font-colorcheck text-promo">Daftar Paket E-Payment</h6>
                    </div>
                    <div class="col-md-1 col-sm-1 col-1 remove-padding">
                        <img class="imageSearch" src="../../assets/icons/search.svg" @click="showsearch" alt="" id="iconsearchepayment">
                    </div>
                </div>
                <div class="row justify-content-center align-items-center set-row showPageSearch">
                    <div class="col-md-9 col-sm-9 col-9 remove-padding">
                        <input class="inputSearch" id="input_search_Epayment" type="text" v-on:keyup="searchsnap"
                               v-model="searchKey"
                               placeholder="Cari..">
                    </div>
                    <div class="col-md-3 col-sm-3 col-3 remove-padding">
                        <img class="imageSearch" v-on:click="closesearch" src="../../assets/img/x2.svg" alt="">
                    </div>
                </div>
            </div>
            <main class="add-padding-default bg-gray">
                <div class="flex-100 showPageSearch">
                    <div class="flex-1" v-if="leght_data >= 0">
                        <div class="Search-BOX mar-top-60 mar-bottom-16" id="textTopepayment"></div>
                        <div class="row set-card" v-for="sp in searchpayment" :key="sp.idpayment">
                            <div class="col-md-10 col-sm-10 col-10 text-left remove-padding">
                                <div><b v-html="searchHighlight(sp.nama_payment, searchKey)"></b></div>
                                <div><img src="../../assets/icons/disc.svg" alt="">
                                    {{sp.nominal_emoney | currency}}
                                    <span v-if="sp.bonus > 0"> + {{sp.bonus | currency}} </span>
                                </div>
                                <div></div>
                                <div><img src="../../assets/icons/clock.svg" alt=""> Aktif {{sp.masa_aktif}} Hari</div>
                                <div class="color-206CF"><img src="../../assets/icons/tag1.svg" alt=""> {{sp.nominal_emoney | currency}}</div>
                            </div>
                            <div class="col-md-2 col-sm-2 col-2 text-right remove-padding dropdown"
                                 id="dropdownMenuLink" :data-toggle="validateAccess('epayment.update') || validateAccess('epayment.delete') ? 'dropdown' : ''" aria-haspopup="true"
                                 aria-expanded="false">
                                <img src="../../assets/icons/more-horizontal2.svg" alt="">
	                            <div class="dropdown-menu garis-deposit" aria-labelledby="dropdownMenuLink">
                                    <a class="dropdown-item icon-1" href="#" @click="edit(sp.idpayment)" v-if="validateAccess('epayment.update')"><span
                                            class="mar-right-10"><i class="far fa-edit color-206CF"></i></span>Ubah</a>
                                    <a class="dropdown-item icon-2" href="#" @click="showmodaldel(sp)" v-if="validateAccess('epayment.delete')"><span
                                            class="mar-right-10"><img src="../../assets/icons/trash-2.svg"></span>Hapus</a>
                                </div>
                            </div>
                        </div>
	                    <div class="loadmoreSpinner" id="loadingSpinnerEpaymentSearch" style="display: none">
		                    <center>
			                    <div class="sp sp-circle"></div>
		                    </center>
	                    </div>
                    </div>
                </div>

                <div class="flex-100 showPageDefault">
                    <div class="flex-1 pad-top-50" v-if="this.leght_data===0">
                        <div class="image text-alignC">
                            <img class="img-fluid" src="../../assets/icons/Hanger.svg" alt="">
                            <h5 class="text-center">Belum ada Paket E-Payment yang terdaftar</h5>
                            <h6 class="text-center">Silahkan klik tombol + untuk menambahkan</h6>
                        </div>
<!--                        <div class="pointer offanimation" @click="createpayment">-->
<!--                            <span class="btn add-menu" href="#" role="button" aria-haspopup="true" aria-expanded="false"><img src="../../assets/img/plus-1.svg" alt=""></span>-->
<!--                        </div>-->
                    </div>
                    <div class="flex-1 pad-top-50" v-else>
                        <div class="card-2">
                            <div class="font-14">Total {{leght_data}} Paket E-payment</div>
                            <FilterSorting :jenisFilter="'epayment'" @filter="filter"/>
                            <br>
                            <div class="row set-card" v-for="E in Epayment" :key="E.idpayment">
                                <div class="col-md-10 col-sm-10 col-10 text-left remove-padding">
                                    <div class="color-33333"><b>{{E.nama_payment}}</b></div>
                                    <div class="color-6f7"><img src="../../assets/icons/disc.svg" alt=""> {{E.nominal_emoney | currency}}
                                        <span class="color-6f7" v-if="E.bonus > 0"> + bonus {{E.bonus | currency}} </span>
                                    </div>
                                    <div></div>
                                    <div class="color-6f7"><img src="../../assets/icons/clock.svg" alt=""> {{E.masa_aktif}}</div>
                                    <div class="color-206CF"><img src="../../assets/icons/tag1.svg" alt=""> {{E.nominal_emoney | currency}}</div>
                                </div>
                                <div class="col-md-2 col-sm-2 col-2 text-right remove-padding dropdown"
                                     :id="'dropdownMenuLinklist'+E.idpayment" :data-toggle="validateAccess('epayment.update') || validateAccess('epayment.delete') ? 'dropdown' : ''" aria-haspopup="true" aria-expanded="false">
                                    <img src="../../assets/icons/more-horizontal2.svg" alt="">
                                    <div class="dropdown-menu garis-snap" aria-labelledby="dropdownMenuLinklist">
                                        <a class="dropdown-item icon-1" href="#" @click="edit(E.idpayment)" v-if="validateAccess('epayment.update')"><span
                                                class="mar-right-10"><i class="far fa-edit color-206CF"></i></span>Ubah</a>
                                        <a class="dropdown-item icon-2" href="#" @click="showmodaldel(E)" v-if="validateAccess('epayment.delete')"><span
                                                class="mar-right-10"><img src="../../assets/icons/trash-2.svg"></span>Hapus</a>
                                    </div>
                                </div>
                            </div>
	                        <div class="loadmoreSpinner" id="loadingSpinnerEpayment" style="display: none">
		                        <center>
			                        <div class="sp sp-circle"></div>
		                        </center>
	                        </div>
                        </div>
<!--                        <div class="pointer offanimation" @click="createpayment">-->
<!--                            <span class="btn add-menu" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><img src="../../assets/img/plus-1.svg" alt=""></span>-->
<!--                        </div>-->
                    </div>
                </div>
	            <div class="modal fade" id="deletemodalepayment" role="dialog">
		            <div class="modal-dialog modal-lg  bani-modal">
			            <div class="modal-content">
				            <div class="modal-header">
					            <div class="nav-btn kiri"></div>
					            <div class="navbar-title text-center">Hapus Paket E-Payment</div>
					            <div class="nav-btn kanan tutup">
						            <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
					            </div>
				            </div>
				            <div class="modal-body">
					            <p class="remove-padding-margin" style="font-size: 16px;letter-spacing: -0.02em;line-height: 140%;">Apakah anda yakin menghapus paket E-payment <b>{{namapaket}}</b>?</p>
				            </div>
				            <div class="modal-footer">
					            <button type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal" @click="Delete">Hapus
					            </button>
				            </div>
			            </div>
		            </div>
	            </div>
	            <div class="flying-button-wrapper" v-if="validateAccess('epayment.create')">
		            <div class="flying-inside">
			            <div class="flying-button btn-add-outlet" @click="createpayment"></div>
		            </div>
	            </div>
            </main>
        </div>
    </div>
</template>

<script>
	import FilterSorting from "@/component-items/FilterSorting";

    export default {
        name: "EpaymentList",
        props:['setidoutletsetdeposit'],
	    components: {FilterSorting},
        data(){
            return{
                isClicked:false,
                searchKey:'',
                searchpayment:[],
                Epayment:[],
                idpayment:'',
                namapaket:'',
                leght_data:0,
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                },
	
	            epaymentPagination: {
		            limit: 20,
		            offset:0,
		            length: 0,
		            pageNumber: 0,
		            sortBy: "nama",
		            orderBy: "ASC",
	            },
	            epaymentSearchPagination: {
		            limit: 20,
		            offset:0,
		            length: 0,
		            pageNumber: 0,
		            sortBy: "nama",
		            orderBy: "ASC",
		            key: ""
	            },
	            
	            listEpaymentCalled: false,
            }
        },
        mounted() {
            this.idoutlet = this.$route.params.idoutlet
            this.idpayment = this.$route.params.idpayment
            $('.showPageSearch').hide()
	
	        $('body').on('DOMSubtreeModified', '#listepayment', () => {
		        if (!this.listEpaymentCalled) {
			        this.listEpaymentCalled = true
			        this.scroll()
		        }
	        });
        },
        methods:{
	        scroll() {
		        window.onscroll = () => {
			        if ($('#loadingSpinnerEpayment').is(":hidden")) {
				        if ($(".showPageDefault").is(":visible")) {
					        if (this.epaymentPagination.pageNumber <= Math.ceil(this.epaymentPagination.length / this.epaymentPagination.limit)) {
						        if (Math.floor($(window).scrollTop()) > 0 && Math.floor($(window).scrollTop()) >= Math.floor($(document).height() - $(window).height()) - 100) {
							        this.epaymentPagination.offset = (this.epaymentPagination.pageNumber * this.epaymentPagination.limit);
							        if (this.epaymentPagination.offset > 0) {
								        this.detailemoney();
							        }
							        $('#loadingSpinnerEpayment').show()
						        }
					        }
				        }
			        }
			
			        if ($('#loadingSpinnerEpaymentSearch').is(":hidden")) {
				        if ($(".showPageSearch").is(":visible")) {
					        if (this.epaymentSearchPagination.pageNumber <= Math.ceil(this.epaymentSearchPagination.length / this.epaymentSearchPagination.limit)) {
						        if (Math.floor($(window).scrollTop()) > 0 && Math.floor($(window).scrollTop()) >= Math.floor($(document).height() - $(window).height()) - 100) {
							        this.epaymentSearchPagination.offset = (this.epaymentSearchPagination.pageNumber * this.epaymentSearchPagination.limit);
							        this.searchsnap()
							        $('#loadingSpinnerEpaymentSearch').show()
						        }
					        }
				        }
			        }
		        }
	        },
        	
            back(){
	            this.listEpaymentCalled = false
	            this.epaymentPagination = {
		            limit: 20,
			            offset:0,
			            length: 0,
			            pageNumber: 0,
			            sortBy: "nama",
			            orderBy: "ASC",
	            }
	            this.epaymentSearchPagination = {
		            limit: 20,
			            offset:0,
			            length: 0,
			            pageNumber: 0,
			            sortBy: "nama",
			            orderBy: "ASC",
			            key: ""
	            }
                this.$emit('backtodetail')
            },

            createpayment(){
                this.$emit('createepaymentt')
            },

            showmodaldel(E){
                this.idpayment = E.idpayment
                this.namapaket=E.nama_payment
                $('#deletemodalepayment').modal('show')
            },
            edit(idpayment){
                this.$emit('editepayment',idpayment)
            },
            showsearch() {
                $(".showPageSearch").show()
                $("#textTopepayment").text("Minimal 2 karakter")
                $(".showPageSearch").addClass("animated slideInDown")
                $(".showPageDefault").hide();
                $("#input_search_Epayment").focus();
            }
            ,
            closesearch() {
                $(".showPageSearch").removeClass("animated slideInDown")
                $(".showPageSearch").hide()
                $(".showPageDefault").show();
                this.searchpayment = "";
                this.searchKey = "";
                $("#textTopepayment").text("Minimal 2 karakter")
	            
	            this.epaymentSearchPagination = {
		            limit: 20,
		            offset:0,
		            length: 0,
		            pageNumber: 0,
		            sortBy: "nama",
		            orderBy: "ASC",
		            key: ""
	            }
            }
            ,
            searchsnap() {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    $(".spinner").prop("style", "display:inline-block");
                    this.SearchFunc();
                }, 500);
            }
            ,
            async SearchFunc() {
	            var key = this.searchKey
	        	if (this.epaymentSearchPagination.offset === 0 || this.epaymentSearchPagination.key !== key){
	                $('#loadingPage').addClass('overlayLoading');
	                $('#loadingPage').show();
	                this.searchpayment = [];
	                $("#textTopepayment").text("Sedang mencari...")
			        this.epaymentSearchPagination = {
				        limit: 20,
				        offset:0,
				        length: 0,
				        pageNumber: 0,
				        sortBy: "nama",
				        orderBy: "ASC",
				        key: key
			        }
		        }
                if (key.length >= 2) {
                    try {
                        const response = await this.$axios.get(this.$baseurl + '/masterData/meta/list_epayment?idoutlet=' + this.setidoutletsetdeposit + '&key=' + key + '&limit=' + this.epaymentSearchPagination.limit + '&offset=' + this.epaymentSearchPagination.offset, this.requestHeaders);
                        if (response.status === 200) {
                            if (response.data.status === true) {
                                $('#loadingPage').removeClass('overlayLoading');
                                $('#loadingPage').hide();
                                this.epaymentSearchPagination.length += response.data.data.length
                                if (response.data.data.length > 0) {
                                    $('#loadingPage').removeClass('overlayLoading');
                                    $('#loadingPage').hide();
                                    $("#textTopepayment").text("Ditemukan " + response.data.data.length + " epayment dengan kata '" + key + "'");
                                    this.convertMiliseconds()
                                    var data = response.data.data
                                    for (var i = 0; i < response.data.data.length; i++) {
                                        this.searchpayment.push({
                                            nama_payment: data[i].emoney.nama,
                                            nominal_emoney: data[i].harga_emoney,
                                            idpayment: data[i].emoney.iddata_emoney,
                                            bonus_emoney: data[i].emoney.saldo,
                                            masa_aktif: this.convertMiliseconds(data[i].emoney.masa_aktif)
                                        })
                                    }
                                } else {
                                    if (this.epaymentSearchPagination.offset === 0) {
	                                    $("#textTopepayment").text("Tidak menemukan '" + key + "'");
	                                    $('#loadingPage').removeClass('overlayLoading');
	                                    $('#loadingPage').hide();
                                    }
                                }
	                            this.epaymentSearchPagination.pageNumber++
                                $('#loadingPage').removeClass('overlayLoading');
                                $('#loadingPage').hide();
                            }
	                        $('#loadingSpinnerEpaymentSearch').hide()
                        }
                    } catch (e) {
	                    $('#loadingSpinnerEpaymentSearch').hide()
                        this.searchpayment=[];
                        $('#loadingPage').removeClass('overlayLoading');
                        $('#loadingPage').hide();
                    }
                } else {
	                $('#loadingSpinnerEpaymentSearch').hide()
                    this.searchpayment=[];
                    this.searchpayment = "";
                    $('#loadingPage').removeClass('overlayLoading');
                    $('#loadingPage').hide();
                    $("#textTopepayment").text("Minimal 2 karakter")
                }
            },

            async listemoney(){
	        	if (this.epaymentPagination.offset === 0) {
			        this.Epayment=[]
			        $('#loadingPage').show();
			        $('#loadingPage').addClass('overlayLoading');
		        }
                var sort_get
                var order_get
                var limit
                var offset
                try{
                    sort_get = this.epaymentPagination.sortBy;
                    order_get = this.epaymentPagination.orderBy;
                    limit = this.epaymentPagination.limit
                    offset = this.epaymentPagination.offset
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/list_epayment?sort_by=' + sort_get + '&order_by=' + order_get + '&limit=' + limit + '&offset=' + offset + '&idoutlet=' + this.setidoutletsetdeposit, this.requestHeaders)
                    if(response.data.status===true){
                        $('#loadingPage').removeClass('overlayLoading');
                        $('#loadingPage').hide();
                        this.epaymentPagination.length += response.data.data.length
                        if (response.data.data.length > 0) {
                        	this.epaymentPagination.pageNumber++
                            $("#iconsearchepayment").show()
                        } else {
                        	if (this.epaymentPagination.offset > 0) {
		                        $("#iconsearchepayment").show()
	                        } else {
		                        $("#iconsearchepayment").hide()
	                        }
                        }
	                    $('#loadingSpinnerEpayment').hide()
                    }
                }catch (e) {
	        		this.$catch_error_response(e)
	                $('#loadingSpinnerEpayment').hide()
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide();
                }
            },
            async detailemoney(refresh = false){
	        	if (this.epaymentPagination.offset === 0 || refresh) {
			        this.epaymentPagination.offset = 0
			        this.Epayment=[]
			        $('#loadingPage').show();
			        $('#loadingPage').addClass('overlayLoading');
		        }
                var sort_get
                var order_get
                var limit
                var offset
                try{
                    sort_get = this.epaymentPagination.sortBy;
                    order_get = this.epaymentPagination.orderBy;
                    limit = this.epaymentPagination.limit
                    offset = this.epaymentPagination.offset
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/list_epayment?idoutlet=' + this.setidoutletsetdeposit + '&sort_by=' + sort_get + '&order_by=' + order_get + '&limit=' + limit + '&offset=' + offset, this.requestHeaders)
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            this.convertMiliseconds()
                            var data = response.data.data
                            this.leght_data=response.data.lenght_data;
                            this.epaymentPagination.length += data.length
                            for (var i = 0; i < data.length; i++) {
                                let aktifDays=this.convertMiliseconds(data[i].emoney.masa_aktif);
                                let bonus = data[i].emoney.saldo - data[i].harga_emoney;
                                let masaAktif = "Aktif Selamanya";

                                if (data[i].emoney.pengaturan_umum.jenis_emoney == 1) {
                                    masaAktif = `Aktif ${aktifDays} Hari`
                                }

                                this.Epayment.push({
                                    nama_payment: data[i].emoney.nama,
                                    nominal_emoney: data[i].harga_emoney,
                                    idpayment: data[i].emoney.iddata_emoney,
                                    bonus_emoney: data[i].emoney.saldo,
                                    bonus: bonus,
                                    masa_aktif: masaAktif,
                                })

                            }
                            $('#loadingPage').removeClass('overlayLoading');
                            $('#loadingPage').hide();
                            if (response.data.data.length > 0) {
                                $("#iconsearchepayment").show()
                            } else {
                            	if (this.epaymentPagination.offset > 0) {
		                            $("#iconsearchepayment").show()
	                            } else {
		                            $("#iconsearchepayment").hide()
	                            }
                            }
	                        this.epaymentPagination.pageNumber++
	                        $('#loadingSpinnerEpayment').hide()
                        }
                    }else{
	                    $('#loadingSpinnerEpayment').hide()
                        $('#loadingPage').removeClass('overlayLoading');
                        $('#loadingPage').hide();
                        this.$toast.error(response.data.msg)
                    }
                }catch (e) {
	        		this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide();
                }
            },
            convertMiliseconds(miliseconds) {
                var days, hours, minutes, seconds, total_hours, total_minutes, total_seconds;

                total_seconds = parseInt(Math.floor(miliseconds / 1000));
                total_minutes = parseInt(Math.floor(total_seconds / 60));
                total_hours = parseInt(Math.floor(total_minutes / 60));
                days = parseInt(Math.floor(total_hours / 24));

                seconds = parseInt(total_seconds % 60);
                minutes = parseInt(total_minutes % 60);
                hours = parseInt(total_hours % 24);

                return days;
            },
            async Delete(){
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const delsnap = new FormData
                    const response = await this.$axios.post(this.$baseurl + '/masterData/epayment/delete_paket_epayment?idemoney=' + this.idpayment + "&idoutlet=" + this.setidoutletsetdeposit,delsnap, this.requestHeaders)
                    if(response.data.status===true){
                        $('#loadingPage').removeClass('overlayLoading');
                        $('#loadingPage').hide();
	                    this.epaymentSearchPagination.offset = 0
                        this.SearchFunc()
	                    this.$toast.success(response.data.msg)
                    }else{
                    	this.$toast.error(response.data.msg)
                        $('#loadingPage').removeClass('overlayLoading');
                        $('#loadingPage').hide();
                    }

                }catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide();
                }
            },
            async sortingEpayment(key) {
                $("#cardWorkshop").hide();
                $("#spinnerWorkshop").prop("style", "display:inline-block");
                switch (key) {
                    case "asc":
                        $('#dropdownMenuButton2').text("Urut Dari A - Z ")
                        this.getsortingEpayment(1)
                        break;
                    case "desc":
                        $('#dropdownMenuButton2').text("Urut Dari Z - A ")
                        this.getsortingEpayment(2)
                        break;
                    case "terbaru":
                        $('#dropdownMenuButton2').text("Urut Dari Terbaru ")
                        this.getsortingEpayment(3)
                        break;
                    case "terlama":
                        $('#dropdownMenuButton2').text("Urut Dari Terlama ")
                        this.getsortingEpayment(4)
                        break;
                    default:
                        $('#dropdownMenuButton2').text("Urutkan ")
                }
            }
            ,
            async getsortingEpayment(datasortingEpayment) {
                var sort_by
                var order_by
                $('#loadingPage').addClass('overlayLoading');
                $('#loadingPage').show();
                try {
                    if (datasortingEpayment === 1) {
                        sort_by = "nama";
                        order_by = "ASC";
                    } else if (datasortingEpayment === 2) {
                        sort_by = "nama";
                        order_by = "DESC";
                    } else if (datasortingEpayment === 3) {
                        sort_by = "created_at";
                        order_by = "DESC";
                    } else if (datasortingEpayment === 4) {
                        sort_by = "created_at";
                        order_by = "ASC";
                    } else {
                        return
                    }
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/list_epayment?idoutlet=' + this.setidoutletsetdeposit + '&order_by=' + order_by + '&sort_by=' + sort_by, this.requestHeaders)
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            this.Epayment = []
                            this.convertMiliseconds()
                            var data = response.data.data
                            for (var i = 0; i < data.length; i++) {
                                this.Epayment.push({
                                    nama_payment: data[i].emoney.nama,
                                    nominal_emoney: data[i].harga_emoney,
                                    idpayment: data[i].emoney.iddata_emoney,
                                    bonus_emoney: data[i].emoney.saldo,
                                    masa_aktif: this.convertMiliseconds(data[i].emoney.masa_aktif)
                                })
                            }
                            $('#loadingPage').removeClass('overlayLoading');
                            $('#loadingPage').hide();
                        }
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide();
                }
            }
            ,
	        filter(payload) {
		        this.epaymentPagination = payload.data;
		        this.detailemoney()
		        $("#dropdownMenuButton-" + payload.type).html(payload.textSorting)
	        }
        }
    }
</script>

<style scoped>
    .image.text-alignC {
        margin-top: 185px;
    }
    .offanimation {
        animation: none;
    }
    .card-2{
        margin-top: 20px;
        margin-bottom: 20px;
    }
</style>